import { statusBadgeClass } from "@/lib/listFormat";
import type { QuoteChip } from "@/lib/submissions/quoteCards";

export function QuoteChipBadge({ chip, id }: { chip: QuoteChip; id?: string }) {
  return (
    <span
      id={id}
      className={`inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${statusBadgeClass(chip.tone)}`}
    >
      {chip.label}
    </span>
  );
}
